export default {
  geolocation: {
    lat: '-34.616000',
    lng: '-58.383000',
    label: 'C1039 Buenos Aires',
  },
  price_rules: {
    grouping: '.',
    decimal: ',',
  },
}
